module.exports = __webpack_public_path__ + "public-ui/img/whatsapp.3fba4ed8.svg";